module.exports = __webpack_public_path__ + "img/mechanical.e54cac18.jpg";